import React from 'react';
import { Icon } from '@unite-us/app-components';

export const ErrorPage = () => (
  <div className="h-full w-full flex items-center justify-center space-x-2">
    <Icon icon="ExclamationCircle" color="red" size={40} />
    <p className="text-20px">
      Error fetching required data. Please refresh.
    </p>
  </div>
);
